<template>
  <div
    class="card"
    style="
      margin-bottom: 10px;
      background-color: #ffffff99;
      box-shadow: 0 4px 10px -2px rgba(0, 0, 0, 0.5) !important;
    "
  >
    <div class="card-body" style="background-color: transparent">
      <div class="row">
        <div class="col-10 col-sm-10 col-md-11 col-lg-11 col-xl-11">
          <p
            style="
              margin: 10px;
              font-family: Ubuntu;
              font-size: 14px;
              font-weight: 900;
              color: #7d0c7e;
            "
          >
            <!-- <i style="margin-right: 10px" class="fas fa-list"></i> -->
            Listado de Ventas Instaladas
          </p>
        </div>

        <div
          class="col-2 col-sm-2 col-md-1 col-lg-1 col-xl-1"
          align="center"
          style="display: flex; gap: 10px; justify-content: flex-end"
        >
          <Skeletor
            v-if="loading"
            :shimmer="true"
            height="20"
            width="100%"
            style="margin: auto"
          />
          <div v-else>
            <div class="d-flex gap-2">
              <div @click="refresh">
                <i
                  style="cursor: pointer; margin: auto"
                  class="fas fa-sync text-sm opacity-10"
                ></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Filters Panel -->
      <div
        class="row mb-3"
        style="
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-wrap: wrap;
        "
        v-if="!loading"
      >
        <!-- Title -->
        <div class="col-12">
          <p
            style="
              margin: 0 0 0 12px;
              font-weight: 600;
              color: #7d0c7e;
              font-size: 14px;
            "
          >
            Filtros
          </p>
        </div>

        <!-- Director Filters -->
        <template v-if="userRole === 'director'">
          <!-- Branch Filter -->
          <div class="col-md-4 mb-2">
            <div class="form-group">
              <label for="branchFilter" class="filter-label">Local:</label>
              <select
                id="branchFilter"
                class="form-select"
                v-model="selectedBranch"
                @change="onBranchChange"
              >
                <option value="all">Todos</option>
                <option
                  v-for="branch in branches"
                  :key="branch"
                  :value="branch"
                >
                  {{ branch }}
                </option>
              </select>
            </div>
          </div>
          <!-- Manager Filter -->
          <div class="col-md-4 mb-2">
            <div class="form-group">
              <label for="managerFilter" class="filter-label">Jefe:</label>
              <select
                id="managerFilter"
                class="form-select"
                v-model="selectedManager"
                @change="onManagerChange"
              >
                <option value="all">Todos</option>
                <option
                  v-for="manager in filteredManagers"
                  :key="manager.id"
                  :value="manager.id"
                >
                  {{ manager.name }}
                </option>
              </select>
            </div>
          </div>
          <!-- SalesRep Filter -->
          <div class="col-md-4 mb-2">
            <div class="form-group">
              <label for="promotorFilter" class="filter-label">Vendedor:</label>
              <select
                id="promotorFilter"
                class="form-select"
                v-model="selectedPromotor"
                @change="applyFilters"
              >
                <option value="all">Todos</option>
                <option
                  v-for="promotor in filteredPromoters"
                  :key="promotor.id"
                  :value="promotor.id"
                >
                  {{ promotor.name }}
                </option>
              </select>
            </div>
          </div>
        </template>

        <!-- Supervisor Filters -->
        <template v-else-if="userRole === 'supervisor'">
          <!-- Branch Filter (only their branches) -->
          <div class="col-md-4 mb-2" v-if="branches.length > 0">
            <div class="form-group">
              <label for="branchFilter" class="filter-label">Local:</label>
              <select
                id="branchFilter"
                class="form-select"
                v-model="selectedBranch"
                @change="onBranchChange"
              >
                <option value="all">Todos</option>
                <option
                  v-for="branch in branches"
                  :key="branch"
                  :value="branch"
                >
                  {{ branch }}
                </option>
              </select>
            </div>
          </div>
          <!-- Manager Filter -->
          <div class="col-md-4 mb-2" v-if="managers.length > 0">
            <div class="form-group">
              <label for="managerFilter" class="filter-label">Jefe:</label>
              <select
                id="managerFilter"
                class="form-select"
                v-model="selectedManager"
                @change="onManagerChange"
              >
                <option value="all">Todos</option>
                <option
                  v-for="manager in filteredManagers"
                  :key="manager.id"
                  :value="manager.id"
                >
                  {{ manager.name }}
                </option>
              </select>
            </div>
          </div>
          <!-- SalesRep Filter -->
          <div class="col-md-4 mb-2" v-if="promoters.length > 0">
            <div class="form-group">
              <label for="promotorFilter" class="filter-label">Vendedor:</label>
              <select
                id="promotorFilter"
                class="form-select"
                v-model="selectedPromotor"
                @change="applyFilters"
              >
                <option value="all">Todos</option>
                <option
                  v-for="promotor in filteredPromoters"
                  :key="promotor.id"
                  :value="promotor.id"
                >
                  {{ promotor.name }}
                </option>
              </select>
            </div>
          </div>
        </template>

        <!-- Manager Filters -->
        <template v-else-if="userRole === 'manager'">
          <!-- SalesRep Filter -->
          <div class="col-md-5 mb-2" v-if="promoters.length > 0">
            <div class="form-group">
              <label for="promotorFilter" class="filter-label">Vendedor:</label>
              <select
                id="promotorFilter"
                class="form-select"
                v-model="selectedPromotor"
                @change="applyFilters"
              >
                <option value="all">Todos</option>
                <option
                  v-for="promotor in promoters"
                  :key="promotor.id"
                  :value="promotor.id"
                >
                  {{ promotor.name }}
                </option>
              </select>
            </div>
          </div>
        </template>

        <!-- Date Filter (for all users) -->
        <div :class="getDateFilterClass()">
          <div class="form-group">
            <label for="dateFilter" class="filter-label">Fecha:</label>
            <select
              id="dateFilter"
              class="form-select"
              v-model="selectedDateFilter"
              @change="applyFilters"
            >
              <option value="all">Todas las Fechas</option>
              <option value="currentMonth">Mes Actual</option>
              <option value="previousMonth">Mes Anterior</option>
            </select>
          </div>
        </div>
      </div>
      <div
        v-if="loading"
        class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
        style="padding: 0px"
      >
        <div class="row">
          <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
            <Skeletor :shimmer="true" height="40" width="50%" />
          </div>

          <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
            <Skeletor
              :shimmer="true"
              height="10"
              pill
              width="30%"
              style="margin-bottom: 10px"
            />
            <Skeletor :shimmer="true" height="40" width="100%" />
          </div>
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <table class="table tablesorter">
              <thead class="thead-light">
                <tr>
                  <th><Skeletor :shimmer="true" height="10" width="100%" /></th>
                  <th v-if="isManager">
                    <Skeletor :shimmer="true" height="10" width="100%" />
                  </th>
                  <th><Skeletor :shimmer="true" height="10" width="100%" /></th>
                  <th v-if="showAccountNumberColumn">
                    <Skeletor :shimmer="true" height="10" width="100%" />
                  </th>
                  <th><Skeletor :shimmer="true" height="10" width="100%" /></th>
                  <th><Skeletor :shimmer="true" height="10" width="100%" /></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                  <td v-if="isManager">
                    <Skeletor :shimmer="true" height="20" width="100%" />
                  </td>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                  <td v-if="showAccountNumberColumn">
                    <Skeletor :shimmer="true" height="20" width="100%" />
                  </td>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                </tr>
                <tr>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                  <td v-if="isManager">
                    <Skeletor :shimmer="true" height="20" width="100%" />
                  </td>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                  <td v-if="showAccountNumberColumn">
                    <Skeletor :shimmer="true" height="20" width="100%" />
                  </td>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                </tr>
                <tr>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                  <td v-if="isManager">
                    <Skeletor :shimmer="true" height="20" width="100%" />
                  </td>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                  <td v-if="showAccountNumberColumn">
                    <Skeletor :shimmer="true" height="20" width="100%" />
                  </td>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="col-6 col-sm-6 col-md-8 col-lg-8 col-xl-8">
            <Skeletor :shimmer="true" height="10" pill width="80%" />
          </div>

          <div class="col-6 col-sm-6 col-md-4 col-lg-4 col-xl-4">
            <div class="row">
              <div class="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                <Skeletor :shimmer="true" height="10" width="100%" />
              </div>

              <div
                class="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4"
                align="center"
              >
                <Skeletor :shimmer="true" circle size="30" />
              </div>

              <div class="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                <Skeletor :shimmer="true" height="10" width="100%" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <DataTable
        v-else
        :columns="columns"
        :options="options"
        :data="filteredSales"
        class="table tablesorter"
        width="100%"
        @row-click="onRowClick"
      >
        <thead>
          <tr>
            <th data-priority="3">Fecha/Hora</th>
            <th v-if="isManager" data-priority="1">Promotor</th>
            <th data-priority="1">Referido</th>
            <th v-if="showAccountNumberColumn" data-priority="2">Nº cuenta</th>
            <th>Celular</th>
            <th>Valor</th>
          </tr>
        </thead>
      </DataTable>
      <!-- Export buttons (managers: períodos; director: también preliquidación MTD) -->
      <div
        style="
          width: auto;
          display: flex;
          justify-content: flex-end;
          flex-wrap: wrap;
          gap: 8px;
        "
        v-if="isManager"
      >
        <button
          v-if="userRole === 'director'"
          @click="exportPreliquidacionMesActual"
          class="btn btn-sm btn-preliquidacion"
          type="button"
          title="Excel con ventas instaladas del mes en curso (hasta hoy)"
        >
          <i class="fas fa-file-invoice-dollar"></i>
          <span style="white-space: nowrap">Preliquidación (mes en curso)</span>
        </button>
        <button
          @click="exportToExcel"
          class="btn btn-sm btn-excel"
          title="Exportar ventas del mes anterior (por updatedAt)"
        >
          <i class="fas fa-file-excel"></i>
          <span style="white-space: nowrap"
            >Exportar
            {{
              new Date(new Date().setMonth(new Date().getMonth() - 1))
                .toLocaleString("es-ES", {
                  month: "long",
                  year: "numeric",
                })
                .replace(" de ", " ")
                .replace(/^[a-z]/, (l) => l.toUpperCase())
            }}</span
          >
        </button>
        <button
          @click="exportYtdToExcel"
          class="btn btn-sm btn-excel"
          title="Exportar ventas del año en curso (YTD, por updatedAt)"
        >
          <i class="fas fa-file-excel"></i>
          <span style="white-space: nowrap">Exportar YTD</span>
        </button>
        <button
          @click="exportHistoricoToExcel"
          class="btn btn-sm btn-excel"
          title="Exportar todo el histórico de ventas instaladas"
        >
          <i class="fas fa-file-excel"></i>
          <span style="white-space: nowrap">Exportar Histórico</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */

import DataTable from "datatables.net-vue3";
import DataTablesCore from "datatables.net-bs5";
import "datatables.net-responsive";
import $ from "jquery";
import ModalCompletarVenta from "./ModalCompletarVenta.vue";
import * as XLSX from "xlsx";

DataTable.use(DataTablesCore);

export default {
  components: {
    DataTable,
    ModalCompletarVenta,
  },
  props: ["userId", "tokenAuth"],
  data() {
    const user = this.$store.state.user;
    // Director, supervisor y manager pueden ver ventas de múltiples usuarios
    const isManager = ["director", "supervisor", "manager"].includes(user.role);
    const isEnterprise = user.type === "enterprise";
    const showPromoterAccountColumn = !isManager && !isEnterprise;
    return {
      loading: true,
      sales: [],
      allSales: [], // Store all sales for filtering
      // Filter selections
      selectedPromotor: "all", // Default to show all promoters (salesRep)
      selectedBranch: "all", // Default to show all branches
      selectedManager: "all", // Default to show all managers
      selectedDateFilter: "all", // Default to show all dates
      // Filter options
      promoters: [], // Will store unique salesReps
      branches: [], // Will store unique branches
      managers: [], // Will store unique managers
      componentKeyModalCompletarVenta: 100,
      idVenta: "",
      showModal: false,
      isManager: isManager,
      columns: [
        {
          data: null,
          render: function (data, type, row) {
            const u = row.updatedAt;
            let d = null;
            if (u && u._seconds != null) {
              d = new Date(
                u._seconds * 1000 + (u._nanoseconds || 0) / 1e6,
              );
            } else if (u && typeof u.toDate === "function") {
              d = u.toDate();
            } else if (u instanceof Date) {
              d = u;
            }
            if (d) {
              return d.toLocaleString("es-ES", {
                timeZone: "America/Guayaquil",
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
              });
            }
            return row.dateFormatted || "-";
          },
        },
        isManager
          ? {
              data: null,
              render: function (data, type, row, meta) {
                // Access isManager from the Vue component instance
                return `${data.promoterNames} ${data.promoterLastnames || ""}`;
              },
            }
          : null,
        {
          data: null,
          render: function (data) {
            return `${data.displayName}  ${
              data.notes?.length > 0
                ? "<br> <b>Nota: </b>" + data.notes[data.notes.length - 1].note
                : ""
            }`;
          },
        },
        showPromoterAccountColumn
          ? {
              data: null,
              render: function (data) {
                const n = data.accountNumber;
                return n != null && String(n).trim() !== ""
                  ? String(n).trim()
                  : "—";
              },
            }
          : null,

        { data: "phone" },
        {
          data: null,
          render: function (data) {
            return data.planValue
              ? `$${Number(data.planValue).toFixed(2)}`
              : "Sin valor";
          },
        },
      ].filter(Boolean),
      options: {
        responsive: true,
        ordering: false,
        lengthMenu: [
          [5, 15, 25, 35, 50, -1],
          [5, 15, 25, 35, 50, "All"],
        ],
        pageLength: 5,
        language: {
          search: "Buscar:",
          sInfo:
            "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
          sInfoEmpty:
            "Mostrando registros del 0 al 0 de un total de 0 registros",
          searchPlaceholder: "Buscar por término...",
          zeroRecords: "Lo sentimos, no se encontraron resultados",
          processing: "Buscando. Espere por favor...",
          sLengthMenu: "Mostrar _MENU_ registros",
          oPaginate: {
            sFirst: "Primero",
            sLast: "Último",
            sNext: "Siguiente",
            sPrevious: "Anterior",
          },
        },
        rowCallback: function (row, data) {
          $(row).on("click", function () {
            // This will be triggered when a row is clicked
            // We'll handle this in our Vue component
          });
          return row;
        },
      },
    };
  },
  computed: {
    /** Solo cuentas tipo promoter (no enterprise); vendedores, no jerárquicos */
    showAccountNumberColumn() {
      if (this.$store.state.user?.type === "enterprise") return false;
      return !this.isManager;
    },
    userRole() {
      const role = this.$store.state.user?.role || "";
      return role.toLowerCase();
    },
    // Filtered managers based on selected branch
    filteredManagers() {
      if (this.selectedBranch === "all") {
        return this.managers;
      }
      return this.managers.filter(
        (manager) => manager.branch === this.selectedBranch,
      );
    },
    // Filtered promoters based on selected manager
    filteredPromoters() {
      if (this.selectedManager === "all") {
        return this.promoters;
      }
      return this.promoters.filter(
        (promoter) => promoter.managerId === this.selectedManager,
      );
    },
    filteredSales() {
      let result = [...this.sales];

      // Apply filters based on role
      if (this.userRole === "director") {
        // Director filters: branch, manager, salesRep
        if (this.selectedBranch !== "all") {
          result = result.filter(
            (sale) => sale.promoterBranch === this.selectedBranch,
          );
        }
        if (this.selectedManager !== "all") {
          result = result.filter(
            (sale) => sale.managerId === this.selectedManager,
          );
        }
        if (this.selectedPromotor !== "all") {
          result = result.filter(
            (sale) => sale.userId === this.selectedPromotor,
          );
        }
      } else if (this.userRole === "supervisor") {
        // Supervisor filters: branch, manager, salesRep
        if (this.selectedBranch !== "all") {
          result = result.filter(
            (sale) => sale.promoterBranch === this.selectedBranch,
          );
        }
        if (this.selectedManager !== "all") {
          result = result.filter(
            (sale) => sale.managerId === this.selectedManager,
          );
        }
        if (this.selectedPromotor !== "all") {
          result = result.filter(
            (sale) => sale.userId === this.selectedPromotor,
          );
        }
      } else if (this.userRole === "manager") {
        // Manager filters: salesRep only
        if (this.selectedPromotor !== "all") {
          result = result.filter(
            (sale) => sale.userId === this.selectedPromotor,
          );
        }
      }
      // SalesRep: no filters needed (only sees own sales)

      // Apply date filter if not "all"
      if (this.selectedDateFilter !== "all") {
        const now = new Date();
        let startDate, endDate;

        if (this.selectedDateFilter === "currentMonth") {
          // Current month: from first day of current month to now
          startDate = new Date(now.getFullYear(), now.getMonth(), 1);
          endDate = now;
        } else if (this.selectedDateFilter === "previousMonth") {
          // Previous month: first instant of day 1 through last ms of last day
          // (day 0 of current month is last day at 00:00 — that would drop día 31 except midnight)
          startDate = new Date(now.getFullYear(), now.getMonth() - 1, 1);
          endDate = new Date(
            new Date(now.getFullYear(), now.getMonth(), 1).getTime() - 1,
          );
        }

        // Filter by updatedAt (mismo criterio que columna Fecha/Hora)
        result = result.filter((sale) => {
          const saleDate = this.parseSaleUpdatedAt(sale);
          if (!saleDate) return false;
          return saleDate >= startDate && saleDate <= endDate;
        });
      }

      return result;
    },
  },
  watch: {
    isManager: function (newVal) {
      if (newVal) {
        console.log("isManager", newVal);
      }
    },
    loading: function (newVal) {
      if (newVal) {
        console.log("loading", newVal);
      }
    },
    promoters: function (newVal) {
      if (newVal) {
        console.log("promoters", newVal);
      }
    },
    selectedPromotor: function (newVal) {
      console.log("Selected promotor changed to:", newVal);
    },
    selectedDateFilter: function (newVal) {
      console.log("Selected date filter changed to:", newVal);
    },
  },
  mounted() {
    this.$eventBus.on("reiniciarModalCompletarVenta", () => {
      this.componentKeyModalCompletarVenta += 1;
      this.showModal = false;
    });
    this.getListado();
  },
  methods: {
    refresh() {
      this.getListado();
    },
    onRowClick(e, data) {
      // Emit the selected sale data to the parent component
      this.$emit("sale-selected", data);
    },
    getListado() {
      this.loading = true;
      this.$https
        .post("/sales/fetchInstalledSales/", {
          tokenAuth: this.tokenAuth,
          userId: this.userId,
        })
        .then((response) => {
          this.loading = false;
          console.log("Response", response);
          console.log("Response.data:", response.data);
          console.log("Response.data.sales:", response.data?.sales);
          console.log("UserRole:", this.userRole);
          this.sales = response.data?.sales || [];
          this.allSales = response.data?.sales ? [...response.data.sales] : []; // Keep a copy of all sales

          console.log("Total sales:", this.allSales.length);
          console.log("Sample sale:", this.allSales[0]);
          console.log("About to extract filters...");

          // Extract unique values for filters based on role
          console.log(
            "Extracting promoters from allSales:",
            this.allSales.length,
          );
          this.extractPromoters();
          console.log("Promoters extracted:", this.promoters.length);

          if (this.userRole === "director" || this.userRole === "supervisor") {
            console.log("Extracting branches and managers...");
            this.extractBranches();
            this.extractManagers();
            console.log("Branches extracted:", this.branches.length);
            console.log("Managers extracted:", this.managers.length);
          }

          console.log(
            "Filters extracted - Branches:",
            this.branches.length,
            "Managers:",
            this.managers.length,
            "Promoters:",
            this.promoters.length,
          );

          // Apply filters and emit the filtered sales
          this.applyFilters();
        })
        .catch((error) => {
          if (error.status === 401) {
            this.$store.dispatch("clearAllData");
            this.$toast.error("Sesión expirada. Inicie sesión nuevamente", {
              position: "top-right",
              max: 10,
            });
            this.$router.push({ name: "Signin" });
          } else if (error.status === 404) {
            this.loading = false;
            this.sales = [];
            this.allSales = [];
            return;
          } else {
            this.$toast.error("Ocurrió un error inesperado", {
              position: "top-right",
              max: 10,
            });
          }
          this.loading = false;
          // this.getListado();
        });
    },
    extractPromoters() {
      // Extract unique salesReps (promoters) from sales data with manager information
      const promotersMap = new Map();

      this.allSales.forEach((sale) => {
        const promoterId = sale.userId;

        if (promoterId && sale.promoterNames) {
          const fullName =
            `${sale.promoterNames} ${sale.promoterLastnames || ""}`.trim();
          if (!promotersMap.has(promoterId)) {
            promotersMap.set(promoterId, {
              id: promoterId,
              name: fullName,
              managerId: sale.managerId, // Store managerId for filtering
            });
          }
        }
      });

      // Convert map to array
      this.promoters = Array.from(promotersMap.values());

      // Sort promoters alphabetically by name
      this.promoters.sort((a, b) => a.name.localeCompare(b.name));
    },
    extractBranches() {
      // Extract unique branches from sales data
      const branchesSet = new Set();

      this.allSales.forEach((sale) => {
        if (sale.promoterBranch) {
          branchesSet.add(sale.promoterBranch);
        }
      });

      this.branches = Array.from(branchesSet).sort();
    },
    extractManagers() {
      // Extract unique managers from sales data with branch information
      const managersMap = new Map();

      this.allSales.forEach((sale) => {
        if (sale.managerId && sale.managerName) {
          if (!managersMap.has(sale.managerId)) {
            managersMap.set(sale.managerId, {
              id: sale.managerId,
              name: sale.managerName,
              branch: sale.managerBranch || sale.promoterBranch, // Store branch for filtering
            });
          }
        }
      });

      this.managers = Array.from(managersMap.values());
      this.managers.sort((a, b) => a.name.localeCompare(b.name));
    },
    getDateFilterClass() {
      // Return appropriate column class based on role and available filters
      if (this.userRole === "director") {
        return "col-md-3 mb-2";
      } else if (this.userRole === "supervisor") {
        return "col-md-4 mb-2";
      } else if (this.userRole === "manager") {
        return "col-md-5 mb-2";
      } else {
        return "col-md-5 mb-2";
      }
    },
    applyFilters() {
      // The actual filtering logic is in the computed property filteredSales
      // This method is just for notifying parent components about the filter change
      this.$emit("sales-updated", this.filteredSales);
    },
    onBranchChange() {
      // When branch changes, reset manager and promoter filters
      this.selectedManager = "all";
      this.selectedPromotor = "all";
      this.applyFilters();
    },
    onManagerChange() {
      // When manager changes, reset promoter filter
      this.selectedPromotor = "all";
      this.applyFilters();
    },
    /** Fecha de la venta para filtros/export (misma lógica que el filtro "Mes actual") */
    parseSaleDateForExport(sale) {
      if (sale.createdAt && sale.createdAt._seconds) {
        return new Date(
          sale.createdAt._seconds * 1000 +
            (sale.createdAt._nanoseconds || 0) / 1e6,
        );
      }
      if (sale.dateFormatted) {
        try {
          const parts = sale.dateFormatted.split(/[/: ]/);
          if (parts.length >= 5) {
            return new Date(
              parts[2],
              parts[1] - 1,
              parts[0],
              parts[3],
              parts[4],
            );
          }
        } catch (e) {
          console.error("Error parsing date:", e);
        }
      }
      return null;
    },
    /** Solo updatedAt — export mes anterior por período de actualización */
    parseSaleUpdatedAt(sale) {
      const u = sale.updatedAt;
      if (!u) return null;
      if (u._seconds != null) {
        return new Date(
          u._seconds * 1000 + (u._nanoseconds || 0) / 1e6,
        );
      }
      if (typeof u.toDate === "function") return u.toDate();
      if (u instanceof Date) return u;
      return null;
    },
    exportPreliquidacionMesActual() {
      if (this.userRole !== "director") return;
      try {
        const now = new Date();
        const startDate = new Date(now.getFullYear(), now.getMonth(), 1);
        const endDate = now;

        const filteredSales = this.filteredSales.filter((sale) => {
          const saleDate = this.parseSaleDateForExport(sale);
          if (!saleDate) return false;
          return saleDate >= startDate && saleDate <= endDate;
        });

        if (filteredSales.length === 0) {
          this.$toast.info(
            "No hay ventas instaladas en el mes en curso para preliquidar",
            {
              position: "top-right",
              max: 10,
            },
          );
          return;
        }

        const monthLabel = now.toLocaleString("es-ES", {
          month: "long",
          year: "numeric",
        });
        const dayStr = now.toLocaleDateString("es-ES", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        });
        this.exportFilteredSalesToExcel(filteredSales, {
          sheetName: "Preliquidación MTD",
          fileName: `Preliquidacion_${monthLabel.replace(/\s+/g, "_")}_al_${dayStr.replace(/\//g, "-")}.xlsx`,
          successToast: `Preliquidación: ${filteredSales.length} ventas (${monthLabel}, hasta ${dayStr})`,
        });
      } catch (error) {
        console.error("Error al exportar preliquidación:", error);
        this.$toast.error("Error al generar la preliquidación", {
          position: "top-right",
          max: 10,
        });
      }
    },
    /** Ventas con filtros de rol/sucursal/promotor, sin filtro de fecha del dropdown */
    salesMatchingRoleFilters() {
      let result = [...this.sales];

      if (this.userRole === "director" || this.userRole === "supervisor") {
        if (this.selectedBranch !== "all") {
          result = result.filter(
            (sale) => sale.promoterBranch === this.selectedBranch,
          );
        }
        if (this.selectedManager !== "all") {
          result = result.filter(
            (sale) => sale.managerId === this.selectedManager,
          );
        }
        if (this.selectedPromotor !== "all") {
          result = result.filter(
            (sale) => sale.userId === this.selectedPromotor,
          );
        }
      } else if (this.userRole === "manager") {
        if (this.selectedPromotor !== "all") {
          result = result.filter(
            (sale) => sale.userId === this.selectedPromotor,
          );
        }
      }

      return result;
    },
    exportToExcel() {
      try {
        const currentDate = new Date();

        const firstDayCurrentMonth = new Date(
          currentDate.getFullYear(),
          currentDate.getMonth(),
          1,
        );

        const firstDayPreviousMonth = new Date(
          currentDate.getFullYear(),
          currentDate.getMonth() - 1,
          1,
        );

        const endPreviousMonth = new Date(firstDayCurrentMonth.getTime() - 1);

        const filteredSales = this.salesMatchingRoleFilters().filter((sale) => {
          const saleDate = this.parseSaleUpdatedAt(sale);
          if (!saleDate) return false;
          return (
            saleDate >= firstDayPreviousMonth && saleDate <= endPreviousMonth
          );
        });

        if (filteredSales.length === 0) {
          this.$toast.info("No hay ventas del mes anterior para exportar", {
            position: "top-right",
            max: 10,
          });
          return;
        }

        const previousMonth = new Date(firstDayPreviousMonth);
        const monthName = previousMonth.toLocaleString("es-ES", {
          month: "long",
        });
        const year = previousMonth.getFullYear();

        this.exportFilteredSalesToExcel(filteredSales, {
          sheetName: "Ventas Mes Anterior",
          fileName: `Ventas_${monthName}_${year}.xlsx`,
          successToast: `Exportadas ${filteredSales.length} ventas de ${monthName}`,
          excelDateSource: "updatedAt",
        });
      } catch (error) {
        console.error("Error al exportar a Excel:", error);
        this.$toast.error("Error al generar el archivo Excel", {
          position: "top-right",
          max: 10,
        });
      }
    },
    exportYtdToExcel() {
      try {
        const now = new Date();
        const startYtd = new Date(now.getFullYear(), 0, 1);

        const filteredSales = this.salesMatchingRoleFilters().filter((sale) => {
          const saleDate = this.parseSaleUpdatedAt(sale);
          if (!saleDate) return false;
          return saleDate >= startYtd && saleDate <= now;
        });

        if (filteredSales.length === 0) {
          this.$toast.info("No hay ventas YTD para exportar", {
            position: "top-right",
            max: 10,
          });
          return;
        }

        const year = now.getFullYear();
        const dayStr = now.toLocaleDateString("es-ES", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        });

        this.exportFilteredSalesToExcel(filteredSales, {
          sheetName: `Ventas YTD ${year}`,
          fileName: `Ventas_YTD_${year}_al_${dayStr.replace(/\//g, "-")}.xlsx`,
          successToast: `Exportadas ${filteredSales.length} ventas YTD ${year}`,
          excelDateSource: "updatedAt",
        });
      } catch (error) {
        console.error("Error al exportar YTD:", error);
        this.$toast.error("Error al generar el archivo Excel", {
          position: "top-right",
          max: 10,
        });
      }
    },
    exportHistoricoToExcel() {
      try {
        const filteredSales = this.salesMatchingRoleFilters();

        if (filteredSales.length === 0) {
          this.$toast.info("No hay ventas históricas para exportar", {
            position: "top-right",
            max: 10,
          });
          return;
        }

        const dateStr = new Date().toISOString().split("T")[0];

        this.exportFilteredSalesToExcel(filteredSales, {
          sheetName: "Ventas Histórico",
          fileName: `Ventas_Historico_${dateStr}.xlsx`,
          successToast: `Exportadas ${filteredSales.length} ventas (histórico)`,
          excelDateSource: "updatedAt",
        });
      } catch (error) {
        console.error("Error al exportar histórico:", error);
        this.$toast.error("Error al generar el archivo Excel", {
          position: "top-right",
          max: 10,
        });
      }
    },
    exportFilteredSalesToExcel(
      filteredSales,
      { sheetName, fileName, successToast, excelDateSource },
    ) {
      const safeNumber = (value, defaultValue = 0) => {
        const num = Number(value);
        return isNaN(num) || !isFinite(num) ? defaultValue : num;
      };

      const salesCount = filteredSales.length;
      let arpu;
      if (salesCount <= 5) {
        arpu = 1;
      } else if (salesCount >= 6 && salesCount <= 12) {
        arpu = 2;
      } else if (salesCount >= 13 && salesCount <= 20) {
        arpu = 2.5;
      } else {
        arpu = 3;
      }

      const exportData = filteredSales.map((sale) => {
        let formattedDate = "-";
        const localeOpts = {
          timeZone: "America/Guayaquil",
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
        };
        if (excelDateSource === "updatedAt") {
          const u = this.parseSaleUpdatedAt(sale);
          if (u) {
            formattedDate = u.toLocaleString("es-ES", localeOpts);
          }
        } else if (sale.date && sale.date._seconds) {
          const date = new Date(
            sale.date._seconds * 1000 + (sale.date._nanoseconds || 0) / 1e6,
          );
          formattedDate = date.toLocaleString("es-ES", localeOpts);
        } else if (sale.createdAt && sale.createdAt._seconds) {
          const date = new Date(
            sale.createdAt._seconds * 1000 +
              (sale.createdAt._nanoseconds || 0) / 1e6,
          );
          formattedDate = date.toLocaleString("es-ES", localeOpts);
        } else if (sale.dateFormatted) {
          formattedDate = sale.dateFormatted;
        }

        const planValue = safeNumber(sale.planValue, 0);
        const valorSinIva = planValue > 0 ? planValue / 1.15 : 0;
        const subtotal = planValue > 0 ? (arpu * planValue) / 1.15 : 0;
        const subtotalConIva = planValue > 0 ? arpu * planValue : 0;

        const paidArpu = sale.paidArpu || false;
        const paidArpuAmount = paidArpu
          ? safeNumber(sale.paidArpuAmount, 0)
          : 0;
        const remainingAmount = subtotalConIva - paidArpuAmount;

        return {
          "Fecha/Hora": formattedDate || "-",
          Promotor: sale.promoterNames
            ? `${sale.promoterNames} ${sale.promoterLastnames || ""}`.trim()
            : "-",
          Cédula:
            sale.promoterDni != null && String(sale.promoterDni).trim() !== ""
              ? String(sale.promoterDni).trim()
              : "-",
          Referido: sale.displayName || "-",
          Celular: sale.phone || "-",
          "Número de cuenta": sale.accountNumber || "-",
          Valor: safeNumber(planValue, 0),
          "Valor sin IVA": safeNumber(valorSinIva, 0),
          ARPU: safeNumber(arpu, 0),
          Subtotal: safeNumber(subtotalConIva, 0),
          "Subtotal sin IVA": safeNumber(subtotal, 0),
          Adelanto: safeNumber(paidArpuAmount, 0),
          "Total a Pagar": safeNumber(remainingAmount, 0),
        };
      });

      const validatedData = exportData.map((row) => {
        const validatedRow = {};
        Object.keys(row).forEach((key) => {
          const value = row[key];
          if (typeof value === "number") {
            validatedRow[key] = isNaN(value) || !isFinite(value) ? 0 : value;
          } else {
            validatedRow[key] = value || "-";
          }
        });
        return validatedRow;
      });

      const worksheet = XLSX.utils.json_to_sheet(validatedData);

      const wscols = [
        { wch: 20 },
        { wch: 30 },
        { wch: 14 },
        { wch: 30 },
        { wch: 15 },
        { wch: 15 },
        { wch: 15 },
        { wch: 15 },
        { wch: 15 },
        { wch: 15 },
        { wch: 15 },
        { wch: 15 },
        { wch: 15 },
      ];

      worksheet["!cols"] = wscols;

      if (worksheet["!ref"]) {
        const range = XLSX.utils.decode_range(worksheet["!ref"]);
        for (let R = range.s.r + 1; R <= range.e.r; ++R) {
          const valorCell = XLSX.utils.encode_cell({ r: R, c: 6 });
          const valorSinIvaCell = XLSX.utils.encode_cell({ r: R, c: 7 });
          const arpuCell = XLSX.utils.encode_cell({ r: R, c: 8 });
          const subtotalCell = XLSX.utils.encode_cell({ r: R, c: 9 });
          const subtotalConIvaCell = XLSX.utils.encode_cell({ r: R, c: 10 });
          const adelantoCell = XLSX.utils.encode_cell({ r: R, c: 11 });
          const totalAPagarCell = XLSX.utils.encode_cell({ r: R, c: 12 });

          [
            valorCell,
            valorSinIvaCell,
            subtotalCell,
            subtotalConIvaCell,
            adelantoCell,
            totalAPagarCell,
          ].forEach((cellAddr) => {
            if (
              worksheet[cellAddr] &&
              typeof worksheet[cellAddr].v === "number"
            ) {
              worksheet[cellAddr].z = '"$"#,##0.00';
            }
          });

          if (
            worksheet[arpuCell] &&
            typeof worksheet[arpuCell].v === "number"
          ) {
            worksheet[arpuCell].z = "#,##0.00";
          }
        }
      }

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

      XLSX.writeFile(workbook, fileName);

      this.$toast.success(successToast, {
        position: "top-right",
        max: 10,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "datatables.net-dt";
@import "datatables.net-responsive-dt";

table thead {
  background-color: #7d0c7e; /* Change to your desired background color */
  color: #ffffff; /* Change font color */
}

/* Optional: Target the <th> elements for more specific styling */
table thead th {
  font-weight: bold; /* Make the text bold */
  padding: 10px; /* Adjust padding for better spacing */
  text-align: left; /* Align text if needed */
}

/* If you want to style a specific table */
table.dataTable thead th {
  background-color: #7d0c7e; /* Specific background color for this table */
  color: white; /* Specific font color */
}

:deep(table tbody tr td) {
  font-weight: bold !important;
}

.btn-excel {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  background-color: #28a745 !important;
  color: white !important;
  border: none !important;
}

.btn-excel:hover {
  background-color: #218838 !important;
}

.btn-preliquidacion {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  background-color: #7d0c7e !important;
  color: white !important;
  border: none !important;
}

.btn-preliquidacion:hover {
  background-color: #5a085b !important;
  color: white !important;
}

/* Promotor filter styles */
.filter-label {
  font-family: Ubuntu;
  font-weight: 600;
  color: #7d0c7e;
  margin-bottom: 5px;
}

.form-select {
  border: 2px solid #f9cc03;
  background-color: white;
  color: #333;
  font-weight: 500;
  padding: 8px;
  border-radius: 4px;
}

.form-select:focus {
  border-color: #7d0c7e;
  box-shadow: 0 0 0 0.2rem rgba(125, 12, 126, 0.25);
}
</style>
